<template>
  <div v-if="riskProfile != null">
    
    <div class="flex items-center">
      <div class="text-lg mr-4">
        Risk Profile - {{ getApplicantName(getClientPrimaryApplicant) }}
      </div>

      <NoteIcon page="risk profile" />
    </div>

    <div class="my-8">


      <div class="overflow-hidden">
        <div class="float-left rounded-full px-4 py-2 bg-gray-300 text-gray-800 text-lg font-light mr-2">1</div>
        <div class="text-lg font-light mt-2">Protecting your lifestyle and assets</div>
      </div>

      <div class="label-line flex items-center">
        <RequiredAsterisk />
        <label class="label-standard">
          Do you have insurance to protect your lifestyle - e.g. life, total permanent disablement, income protection?
        </label>
      </div>

      <div class="form-line flex items-center">
        <InputRadio 
          name="inputInsurance"
          id="inputInsuranceYes"
          propertyKey="insurance"
          value="1"
          :checked="riskProfile.insurance == 1"
          :updateValue="updateValue" />

        <label for="inputInsuranceYes" class="text-base ml-2 mr-8">Yes</label>

        <InputRadio 
          name="inputInsurance"
          id="inputInsuranceNo"
          propertyKey="insurance"
          value="0"
          :checked="riskProfile.insurance == 0"
          :updateValue="updateValue" />

        <label for="inputInsuranceNo" class="text-base ml-2">No</label>
      </div>


      <div class="label-line">
        <div class="label-standard">
          How would your lifestyle need to be maintained if you and / or your partner were:
        </div>

        <div class="mt-4 text-sm">
          * Temporarily unable to earn an income, for example through sickness / illness?
        </div>

        <div class="mt-1 text-sm">
          * Permanently unable to earn income, for example through death / permanent disability?
        </div>
      </div>

      <div class="form-line w-1/2">
        <TextareaField 
          propertyKey="how_maintained"
          :value="riskProfile.how_maintained"
          :updateValue="updateValue" />
      </div>





      <template v-if="riskProfile.insurance != null && riskProfile.insurance == 1">
        <div class="label-line">
          <label class="label-standard">What type of insurance?</label>
        </div>

        <div class="mt-4 flex items-center">
          <div class="mr-8" style="width:250px;">
            <label for="inputLifeYes" class="text-base">Life insurance</label>
          </div>

          <InputRadio 
            name="inputLife"
            id="inputLifeYes"
            propertyKey="life"
            value="1"
            :checked="riskProfile.life == 1"
            :updateValue="updateValue" />

          <label for="inputLifeYes" class="text-base ml-2 mr-8">Yes</label>

          <InputRadio 
            name="inputLife"
            id="inputLifeNo"
            propertyKey="life"
            value="0"
            :checked="riskProfile.life == 0"
            :updateValue="updateValue" />

          <label for="inputLifeNo" class="text-base ml-2">No</label>
        </div>

        <div class="mt-4 flex items-center">
          <div class="mr-8" style="width:250px;">
            <label for="inputLifeYes" class="text-base">Total and Permanent Disability</label>
          </div>

          <InputRadio 
            name="inputDisability"
            id="inputDisabilityYes"
            propertyKey="disability"
            value="1"
            :checked="riskProfile.disability == 1"
            :updateValue="updateValue" />

          <label for="inputDisabilityYes" class="text-base ml-2 mr-8">Yes</label>
          
          <InputRadio 
            name="inputDisability"
            id="inputDisabilityNo"
            propertyKey="disability"
            value="0"
            :checked="riskProfile.disability == 0"
            :updateValue="updateValue" />

          <label for="inputDisabilityNo" class="text-base ml-2">No</label>
        </div>

        <div class="mt-4 flex items-center">

          <div class="mr-8" style="width:250px;">
            <label for="inputLifeYes" class="text-base">Income Protection</label>
          </div>

          <InputRadio 
            name="inputProtection"
            id="inputProtectionYes"
            propertyKey="protection"
            value="1"
            :checked="riskProfile.protection == 1"
            :updateValue="updateValue" />

          <label for="inputProtectionYes" class="text-base ml-2 mr-8">Yes</label>
          
          <InputRadio 
            name="inputProtection"
            id="inputProtectionNo"
            propertyKey="protection"
            value="0"
            :checked="riskProfile.protection == 0"
            :updateValue="updateValue" />

          <label for="inputProtectionNo" class="text-base ml-2">No</label>
        </div>
      </template>


      <div class="label-line flex items-center">
        <RequiredAsterisk />
        <label class="label-standard">
          Would you like your broker to refer someone to review your personal insurance situation??
        </label>
      </div>

      <div class="form-line flex items-center">
        <InputRadio 
          name="inputReview"
          id="inputReviewYes"
          propertyKey="review"
          value="1"
          :checked="riskProfile.review == 1"
          :updateValue="updateValue" />

        <label for="inputReviewYes" class="text-base ml-2 mr-8">Yes</label>
        
        <InputRadio 
          name="inputReview"
          id="inputReviewNo"
          propertyKey="review"
          value="0"
          :checked="riskProfile.review == 0"
          :updateValue="updateValue" />

        <label for="inputReviewNo" class="text-base ml-2 mr-8">No</label>
      </div>




      <div class="label-line flex items-center">
        <RequiredAsterisk />
        <label class="label-standard">
          Do you have any home and contents insurance?
        </label>
      </div>

      <div class="form-line flex items-center">
        <InputRadio 
          name="inputHomeContentsInsurance"
          id="inputHomeContentsInsuranceYes"
          propertyKey="has_home_contents_insurance"
          value="1"
          :checked="riskProfile.has_home_contents_insurance == 1"
          :updateValue="updateValue" />

        <label for="inputHomeContentsInsuranceYes" class="text-base ml-2 mr-8">Yes</label>
        
        <InputRadio 
          name="inputHomeContentsInsurance"
          id="inputHomeContentsInsuranceNo"
          propertyKey="has_home_contents_insurance"
          value="0"
          :checked="riskProfile.has_home_contents_insurance == 0"
          :updateValue="updateValue" />

        <label for="inputHomeContentsInsuranceNo" class="text-base ml-2 mr-8">No</label>
      </div>










      <div class="label-line flex items-center">
        <RequiredAsterisk />
        <label class="label-standard">
          Would you like someone to contact you regarding your home and contents insurance?
        </label>
      </div>

      <div class="form-line flex items-center">
        <InputRadio 
          name="inputContactHomeContentsInsurance"
          id="inputContactHomeContentsInsuranceYes"
          propertyKey="contact_for_home_contents_insurance"
          value="1"
          :checked="riskProfile.contact_for_home_contents_insurance == 1"
          :updateValue="updateValue" />

        <label for="inputContactHomeContentsInsuranceYes" class="text-base ml-2 mr-8">Yes</label>
        
        <InputRadio 
          name="inputContactHomeContentsInsurance"
          id="inputContactHomeContentsInsuranceNo"
          propertyKey="contact_for_home_contents_insurance"
          value="0"
          :checked="riskProfile.contact_for_home_contents_insurance == 0"
          :updateValue="updateValue" />

        <label for="inputContactHomeContentsInsuranceNo" class="text-base ml-2 mr-8">No</label>
      </div>







      
      <div class="label-line label-standard">
        <RequiredAsterisk />  
        Do you have a <span class="uppercase">current</span> will in place?
        If you don't have a will, the court will appoint an administrator who may not act to ensure your family's needs are met according to their wishes.
      </div>

      <div class="form-line flex items-center">
        <InputRadio 
          name="inputWill"
          id="inputWillYes"
          propertyKey="will"
          value="1"
          :checked="riskProfile.will == 1"
          :updateValue="updateValue" />

        <label for="inputWillYes" class="text-base ml-2 mr-8">Yes</label>
        
        <InputRadio 
          name="inputWill"
          id="inputWillNo"
          propertyKey="will"
          value="0"
          :checked="riskProfile.will == 0"
          :updateValue="updateValue" />

        <label for="inputWillNo" class="text-base ml-2 mr-8">No</label>
      </div>











      <div class="overflow-hidden mt-16">
        <div class="float-left rounded-full px-4 py-2 bg-gray-300 text-gray-800 text-lg font-light mr-2">2</div>
        <div class="text-lg font-light mt-2">Credit History and changes to circumstances</div>
      </div>

      <div class="label-line flex items-center">
        <RequiredAsterisk />
        <label class="label-standard">
          Have you had any difficulties in meeting your financial commitments in the last two years?
        </label>
      </div>

      <div class="form-line flex items-center">
        <InputRadio 
          name="inputProblem"
          id="inputProblemYes"
          propertyKey="problems"
          value="1"
          :checked="riskProfile.problems == 1"
          :updateValue="updateValue" />

        <label for="inputProblemYes" class="text-base ml-2 mr-8">Yes</label>

        <InputRadio 
          name="inputProblem"
          id="inputProblemNo"
          propertyKey="problems"
          value="0"
          :checked="riskProfile.problems == 0"
          :updateValue="updateValue" />

        <label for="inputProblemNo" class="text-base ml-2">No</label>
      </div>

      <template v-if="riskProfile.problems == 1">
        <div class="label-line">
          <TextareaField 
            label="Please provide more information"
            propertyKey="problems_text"
            :value="riskProfile.problems_text"
            :updateValue="updateValue" />
        </div>
      </template>

      <div class="label-line flex items-center">
        <RequiredAsterisk />
        <label class="label-standard">
          Do you foresee any changes to your income that will decrease your ability to meet your obligations in the reasonable foreseeable future
          - 
          e.g. pending retirement, work changes due to family circumstances, returning to study, etc.?
        </label>
      </div>

      <div class="form-line flex items-center">
        <InputRadio 
          name="inputIncome"
          id="inputIncomeYes"
          propertyKey="income"
          value="1"
          :checked="riskProfile.income == 1"
          :updateValue="updateValue" />

        <label for="inputIncomeYes" class="text-base ml-2 mr-8">Yes</label>

        <InputRadio 
          name="inputIncome"
          id="inputIncomeNo"
          propertyKey="income"
          value="0"
          :checked="riskProfile.income == 0"
          :updateValue="updateValue" />

        <label for="inputIncomeNo" class="text-base ml-2">No</label>
      </div>

      <template v-if="riskProfile.income == 1">
        <div class="label-line">
          <TextareaField 
            label="Please provide more information"
            propertyKey="income_text"
            :value="riskProfile.income_text"
            :updateValue="updateValue"/>
        </div>
      </template>




    





      <div class="overflow-hidden mt-16">
        <div class="float-left rounded-full px-4 py-2 bg-gray-300 text-gray-800 text-lg font-light mr-2">3</div>
        <div class="text-lg font-light mt-2">Goals and objectives</div>
      </div>

      <div class="label-line p-4 bg-yellow-200 text-sm overflow-hidden rounded border-yellow-400 w-1/2">
        <div class="float-left" style="margin-top:5px;">
          <img src="https://cdn2.iconfinder.com/data/icons/officeicons/PNG/48/Help.png" class="w-4" />
        </div>

        <div class="ml-6 leading-normal">
          Under NCCP regulations (National Consumer Credit Code), ASIC requires lending institutions to have you to complete this section to ensure that your broker recommends a loan that is <b>not unsuitable</b> for your needs.
        </div>
      </div>

      <div class="label-line w-1/2">
        <TextareaField 
          label="Short-term goals (1 to 5 years) - e.g. 'Obtain loan for own home or investment'"
          propertyKey="short_term"
          :value="riskProfile.short_term"
          :updateValue="updateValue"/>
      </div>

      <div class="label-line w-1/2">
        <TextareaField 
          label="Medium-term goals (6 to 15 years) - e.g. 'Pay down loan as quickly as possible'"
          propertyKey="medium_term"
          :value="riskProfile.medium_term"
          :updateValue="updateValue"/>
      </div>

      <div class="label-line w-1/2">
        <TextareaField 
          label="Long-term goals (16 to 30 years) - e.g. 'Invest for retirement'"
          propertyKey="long_term"
          :value="riskProfile.long_term"
          :updateValue="updateValue"/>
      </div>

      <div class="label-line w-1/2">
        <template v-if="riskProfile.retire_at != null">
          <InputDatePickerReadOnly 
            label="What is your anticipated retirement date?"
            propertyKey="retire_at"
            :minDate="getFutureDate(1, 'days')"
            :maxDate="getFutureDate(90, 'years')"
            :value="riskProfile.retire_at"
            :updateValue="updateValue" />
        </template>

        <template v-else>
          <div class="label-standard">What is your anticipated retirement age?</div>
      
          <!-- <InputNumber 
            label="What is your anticipated retirement age?"
            propertyKey="retirement_age"
            :value="riskProfile.retirement_age"
            :updateValue="updateValue" /> -->
          <div class="form-line">
            <select class="select-standard h-10" 
              :value="riskProfile.retirement_age"
              @change="updateValue({
              key       : 'retirement_age',
              value     : $event.target.value
            })">
              <option :value="null" disabled>Please select your anticipated retirement age</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
              <option value="32">32</option>
              <option value="33">33</option>
              <option value="34">34</option>
              <option value="35">35</option>
              <option value="36">36</option>
              <option value="37">37</option>
              <option value="38">38</option>
              <option value="39">39</option>
              <option value="40">40</option>
              <option value="41">41</option>
              <option value="42">42</option>
              <option value="43">43</option>
              <option value="44">44</option>
              <option value="45">45</option>
              <option value="46">46</option>
              <option value="47">47</option>
              <option value="48">48</option>
              <option value="49">49</option>
              <option value="50">50</option>
              <option value="51">51</option>
              <option value="52">52</option>
              <option value="53">53</option>
              <option value="54">54</option>
              <option value="55">55</option>
              <option value="56">56</option>
              <option value="57">57</option>
              <option value="58">58</option>
              <option value="59">59</option>
              <option value="60">60</option>
              <option value="61">61</option>
              <option value="62">62</option>
              <option value="63">63</option>
              <option value="64">64</option>
              <option value="65">65</option>
              <option value="66">66</option>
              <option value="67">67</option>
              <option value="68">68</option>
              <option value="69">69</option>
              <option value="70">70</option>
              <option value="71">71</option>
              <option value="72">72</option>
              <option value="73">73</option>
              <option value="74">74</option>
              <option value="75">75</option>
              <option value="76">76</option>
              <option value="77">77</option>
              <option value="78">78</option>
              <option value="79">79</option>
              <option value="80">80</option>
              <option value="81">81</option>
              <option value="82">82</option>
              <option value="83">83</option>
              <option value="84">84</option>
              <option value="85">85</option>
              <option value="86">86</option>
              <option value="87">87</option>
              <option value="88">88</option>
              <option value="89">89</option>
              <option value="90">90</option>
              <option value="91">91</option>
              <option value="92">92</option>
              <option value="93">93</option>
              <option value="94">94</option>
              <option value="95">95</option>
              <option value="96">96</option>
              <option value="97">97</option>
              <option value="98">98</option>
              <option value="99">99</option>
              <option value="100">100</option>
              <option value="101">101</option>
              <option value="102">102</option>
              <option value="103">103</option>
              <option value="104">104</option>
              <option value="105">105</option>
              <option value="106">106</option>
              <option value="107">107</option>
              <option value="108">108</option>
              <option value="109">109</option>
              <option value="110">110</option>
              <option value="111">111</option>
              <option value="112">112</option>
              <option value="113">113</option>
              <option value="114">114</option>
              <option value="115">115</option>
              <option value="116">116</option>
              <option value="117">117</option>
              <option value="118">118</option>
              <option value="119">119</option>
              <option value="120">120</option>
            </select>
          </div>
        </template>
      </div>

      <div class="label-line w-1/2">
        <TextareaField 
          label="How do you plan to reduce/clear your debt prior to retirement?"
          propertyKey="retirement"
          :value="riskProfile.retirement"
          :updateValue="updateValue"/>
      </div>


      <div class="label-standard mt-10">
        Before this, have you approached a lender or finance broker regarding finance for this loan?
      </div>


      <div class="mt-1 flex items-center mb-10">
        <InputRadio 
          name="inputFinance"
          id="inputFinanceYes"
          propertyKey="finance"
          value="1"
          :checked="riskProfile.finance == 1"
          :updateValue="updateValue" />

        <label for="inputFinanceYes" class="text-base ml-2 mr-8">Yes</label>

        <InputRadio 
          name="inputFinance"
          id="inputFinanceNo"
          propertyKey="finance"
          value="0"
          :checked="riskProfile.finance == 0"
          :updateValue="updateValue" />

        <label for="inputFinanceNo" class="text-base ml-2">No</label>
      </div>

      <div class="label-standard label-line">
        <RequiredAsterisk />  
        Before this, have you received advice from an accountant, solicitor or financial planner about your financial objectives?
      </div>

      <div class="mt-1 flex items-center">
        <InputRadio 
          name="inputAdvice"
          id="inputAdviceYes"
          propertyKey="advice"
          value="1"
          :checked="riskProfile.advice == 1"
          :updateValue="updateValue" />

        <label for="inputAdviceYes" class="text-base ml-2 mr-8">Yes</label>

        <InputRadio 
          name="inputAdvice"
          id="inputAdviceNo"
          propertyKey="advice"
          value="0"
          :checked="riskProfile.advice == 0"
          :updateValue="updateValue" />

        <label for="inputAdviceNo" class="text-base ml-2">No</label>
      </div>

      <template v-if="riskProfile.advice == 0">
        <div class="label-standard label-line">
          Would you like your broker to refer someone to review your financial situation?
        </div>

        <div class="mt-1 flex items-center">
          <InputRadio 
            name="input-refer-financials"
            id="input-refer-financials-yes"
            propertyKey="refer_financials"
            value="1"
            :checked="riskProfile.refer_financials == 1"
            :updateValue="updateValue" />

          <label for="input-refer-financials-yes" class="text-base ml-2 mr-8">Yes</label>

          <InputRadio 
            name="input-refer-financials-no"
            id="input-refer-financials-no"
            propertyKey="refer_financials"
            value="0"
            :checked="riskProfile.refer_financials == 0"
            :updateValue="updateValue" />

          <label for="input-refer-financials-no" class="text-base ml-2">No</label>
        </div>
      </template>

      <div class="mt-8" v-if="riskProfile.advice == 1">
        <FinancialPlanner></FinancialPlanner>
      </div>
    </div>

    <div class="button-line">
      <ApplicationButton />
    </div>

    <br/><br/><br/>
  </div>
</template>

<script>
  import InputRadio               from '@/shared/components/form/InputRadio'
  import InputCheckbox            from '@/shared/components/form/InputCheckbox'
  import InputText                from '@/shared/components/form/InputText'
  import RequiredAsterisk         from '@/shared/components/form/RequiredAsterisk'
  import TextareaField            from '@/shared/components/form/TextareaField'
  import { EventBus }             from '@/shared/event-bus'
  import FinancialPlanner         from './FinancialPlanner'
  import ApplicationButton        from '@/shared/components/form/ApplicationButton'
  import InputDatePickerReadOnly  from '@/shared/components/form/InputDatePickerReadOnly'
  import InputNumber              from '@/shared/components/form/InputNumber'
  import NoteIcon                 from '@/shared/components/NoteIcon'

  export default {

    components: {
      InputText,
      RequiredAsterisk,
      InputRadio,
      InputCheckbox,
      TextareaField,
      InputDatePickerReadOnly,
      FinancialPlanner,
      ApplicationButton,
      InputNumber,
      NoteIcon,
    },

    data () {
      return {
        riskProfile: null,
      }
    },

    created() {
      this.logActivity({
        type        : 'risk-profile-visited',
        clientId    : this.$route.params.clientId,
        currentView : this.$store.state.view
      })

      this.showLoader("Loading risk profile...")
      this.apiGet({
        clientId : this.$route.params.clientId
      }, 'risk-profile/detail', (riskProfile) => {
        this.hideLoader()
        this.riskProfile = riskProfile
      })
    },

    methods : {
      // a method that will receive the value and update
      // only edit if the values are different
      updateValue(params) {
        if(this.riskProfile[params.key] != params.value) {
          EventBus.$emit('set-autosave', true)
          this.$set(this.riskProfile, params.key, params.value)
          this.apiPost({
            clientId: this.$route.params.clientId,
            key     : params.key,
            value   : params.value            
          }, 'risk-profile/edit', () => {
            EventBus.$emit('set-autosave', false)
          })
        }
      },

      submit() {
        this.$router.push({ 
          name  : 'application-document',
          params: {
            applicantId : this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].id
          }
        })
      },
    },

    metaInfo () {
      return {
        title: 'Risk Profile - ' + (this.getClientPrimaryApplicant != null ? this.getApplicantName(this.getClientPrimaryApplicant) : '') + " | Brokerpad"
      }
    }
  }
</script>